<template>
  <SlideIn
    :open="isOpen"
    heading="Wishlist"
    :content-padding="false"
    @close="isOpen = false"
  >
    <template #content>
      <div class="account__wrapper">
        <p class="text">
          Please login or register to save products to your wishlist
        </p>
        <template v-if="!showForgottenPassword">
          <div class="container">
            <Tabs>
              <Tab name="Login to your account">
                <SingleSignOn />
                <LoginForm @success="handleLoginSuccess" />
                <div class="forgotten-password-button">
                  <Button
                    type="button"
                    width="full"
                    theme="secondary"
                    @click="showForgottenPassword = true"
                  >
                    Forgotten password?
                  </Button>
                </div>
              </Tab>
              <Tab name="New customer?">
                <RegisterPanel :show-offer-text="false" />
              </Tab>
            </Tabs>
          </div>
        </template>

        <AccountRecovery v-if="showForgottenPassword" />
      </div>
    </template>
  </SlideIn>
</template>

<script>
import SlideIn from "@/components/SlideIn.vue";
import AccountRecovery from "@/components/account/AccountRecovery.vue";
import LoginForm from "@/components/account/LoginForm.vue";
import RegisterPanel from "@/components/account/RegisterPanel.vue";
import Button from "@/components/ButtonV3.vue";
import SingleSignOn from "@/components/SingleSignOn.vue";
import Tab from "@/components/Tab.vue";
import Tabs from "@/components/Tabs.vue";

import { mapState, mapActions } from "vuex";

export default {
  name: "WishlistLogin",
  components: {
    LoginForm,
    AccountRecovery,
    Tabs,
    Tab,
    RegisterPanel,
    SingleSignOn,
    Button,
    SlideIn,
  },
  data() {
    return {
      showForgottenPassword: false,
    };
  },
  computed: {
    ...mapState("app", ["isWishlistLoginOpen"]),
    ...mapState("auth", ["multipassAccount"]),
    isOpen: {
      get() {
        return this.isWishlistLoginOpen;
      },
      set(value) {
        return this.setWishlistLoginOpenState(value);
      },
    },
  },
  methods: {
    ...mapActions("app", ["setWishlistLoginOpenState", "addItemToWishlist"]),
    async handleLoginSuccess() {
      this.isOpen = false;

      const productVariantId = localStorage.getItem("ratandboaGuestWishlist");

      try {
        if (productVariantId) {
          await this.addItemToWishlist({
            productVariantId,
            action: "add",
          });
        }
      } catch (error) {
        console.error("Failed to save wishlist item after login:", error);
      } finally {
        localStorage.removeItem("ratandboaGuestWishlist");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.account__wrapper {
  padding: 20px 0 30px;

  .text {
    padding: 0 20px;
    font-size: 16px;
    text-align: left;
    font-family: $editorial-font-family;
    line-height: 1.4;
    max-width: 400px;
    margin: 0 auto;
  }
}

.container {
  padding: 0 20px;
  margin-top: 20px;
}

.forgotten-password-button {
  margin-top: 20px;
  padding: 0;
}

:deep(.tabs__content) {
  padding: 0;
}

:deep(.tabs__list) {
  .tab {
    font-family: $editorial-font-family;
    font-size: 16px;
  }
}

:deep(.tabs__panel) {
  margin-top: 10px;
}
</style>
